import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../services/user/user.service';
import { JwtService } from '../auth/jwt.service';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  showloginscreen: boolean;
  showregisterscreen: boolean;
  staticText: string;
  accessToken: string;
  showforgotscreen: boolean;

  isLoginError: boolean = false;
  isLoading: boolean = false;
  isRegisterSuccess: boolean = false;

  noEmail: boolean = false;
  isAuth : string = "";

  constructor(private router: Router, private userService: UserService,
    private jwtServices: JwtService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.showloginscreen = true;
    this.showregisterscreen = false;
    this.showforgotscreen = false;

    if (localStorage.getItem("userToken") != null) {
      this.router.navigate(['/dashboard']);
    }
    else if (localStorage.getItem('userToken') == null) {
      this.accessToken = this.getCookie('msloginuser');
      if (this.accessToken != null) {
        this.jwtServices.saveToken(this.accessToken);
        this.userService.populateUserData();
        this.router.navigate(['/dashboard']);
      }
    }
    else { }

    this.activatedRoute.queryParams.subscribe(params => {
      this.isAuth = params['status'];
      if(this.isAuth == "false")
      {
        alert("This account does not have access to the app");
        this.isAuth = "";
      }
      if(this.isAuth == "inactive")
      {
        alert("Your account is deactivated.");
        this.isAuth = "";
      }
    });

  }

  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // ShowRegister()
  // {
  //   this.showloginscreen = false;
  //   this.showregisterscreen = true;
  // }
  // ShowLogin()
  // {
  //   this.showloginscreen = true;
  //   this.showregisterscreen = false;
  // }

  ShowLogin() {
    this.showloginscreen = true;
    this.showregisterscreen = false;
    this.showforgotscreen = false;
  }

  OnForgotSubmit(form : NgForm) {
    this.isLoading = true;
    this.isRegisterSuccess = false;
    this.isLoginError = false;
    console.log(form.value);
    this.userService.ForgotPassword(form.value).subscribe(
      (data: any) => {
        console.log(data);
        if (data == true) {
          this.isLoading = false;
          this.isRegisterSuccess = true;
          this.isLoginError = false;
          if(this.noEmail == true)
          {
            alert("Password change request has been created");
          }
          else{
            alert("Please check your email to reset password");
          }
        }
        else {
          this.isLoading = false;
          this.isRegisterSuccess = false;
          this.isLoginError = true;
        }
      }
    )

    //this.isLoading = false;
    //this.isRegisterSuccess = true;
    //this.isLoginError = false;

  }

  checkEmail(e) {
    if (e.target.checked) {
      this.noEmail = true;

    }
    else {
      this.noEmail = false;
    }
  }

}
